(function () {
  'use strict';

  if (window.__fbpFilterMenuRebuildLoaded) return;
  window.__fbpFilterMenuRebuildLoaded = true;

  var READY_CLASS = 'fbp-filter-rebuild-ready';
  var FILTER_OPEN_CLASS = 'fbp-filter-mobile-open';
  var FILTER_COLLAPSED_CLASS = 'fbp-filter-desktop-collapsed';
  var LEGACY_FILTER_COLLAPSED_CLASS = 'fbp-desktop-filter-collapsed';
  var MENU_READY_CLASS = 'fbp-mobile-menu-rebuild-ready';
  var MENU_OPEN_CLASS = 'fbp-mobile-menu-open';
  // While the drawer is still sliding in (~220ms) plus the usual synthetic
  // click delay after a touch tap (~50-300ms), we suppress interactions with
  // the drawer surface so the tap that opened the menu cannot immediately
  // close it by landing on the X button or navigate away by landing on a
  // link. Customers reported the menu "flickers on and off" and "needs to be
  // clicked multiple times to stay open" — that is exactly this synthetic
  // click falling on the drawer as it travels under the finger.
  var MENU_OPENING_CLASS = 'fbp-mobile-menu-opening';
  var MENU_OPENING_GRACE_MS = 350;
  var MENU_OPENING_TIMER = 0;

  var FILTER_DATA_PARAM_KEYS = ['fbp_type', 'fbp_cat', 'fbp_artist', 'fbp_gender', 'fbp_sort'];
  var PRESERVE_PARAM_KEYS = ['preview_theme_id', 'view', '_ab', '_fd', '_sc'];
  var DEFAULT_SORT_KEY = 'manual';
  var MOBILE_BREAKPOINT = 1199;
  var ALL_PRODUCTS_PATH = '/collections/all';
  var SECTION_CONFIG = {
    productType: { title: 'Product type' },
    categories: { title: 'Categories' },
    artists: { title: 'Art by' },
    genders: { title: 'Gender' },
  };

  var DATA = null;
  var INDEX = {
    productTypes: new Map(),
    categories: new Map(),
    sortModes: new Map(),
    artists: new Map(),
    genders: new Map(),
  };
  var STATE = null;
  var UI = {
    sidebarRoot: null,
    topBar: null,
    filterButton: null,
    grid: null,
    gridWrap: null,
    sortHost: null,
    mobileOverlay: null,
    mobileMenuOverlay: null,
    mobileMenuDrawer: null,
  };

  var SEARCH_STATE = Object.keys(SECTION_CONFIG).reduce(function (accumulator, key) {
    accumulator[key] = '';
    return accumulator;
  }, {});

  var SORT_OPTION_LABELS = {
    manual: 'Featured',
    'best-selling-all-time': 'Best selling all times',
    'best-selling-30-days': 'Best selling in the last 30 days',
    'title-ascending': 'Alphabetically, A-Z',
    'title-descending': 'Alphabetically, Z-A',
    'created-descending': 'Date, new to old',
    'created-ascending': 'Date, old to new',
  };

  // Shared low-level utilities used by both the filter UI and the mobile menu.
  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function slugify(value) {
    return normalizeText(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function unique(values) {
    return Array.from(new Set((values || []).filter(Boolean)));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isCollectionPage() {
    return !!(document.body && document.body.classList.contains('template-collection'));
  }

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function currentScriptElement() {
    if (document.currentScript) return document.currentScript;
    return Array.prototype.find.call(document.scripts, function (script) {
      return /fbp-filter-menu-rebuild\.js/.test(script.src || '');
    }) || null;
  }

  function resolveAssetUrl(filename) {
    var script = currentScriptElement();
    if (script && script.src) {
      return new URL(filename, script.src).toString();
    }
    return filename;
  }

  function dataUrl() {
    if (window.__fbpFilterMenuDataUrl) return window.__fbpFilterMenuDataUrl;
    var cfg = window.__fbpFilterMenuRebuildConfig;
    if (cfg && typeof cfg.dataUrl === 'string' && cfg.dataUrl) return cfg.dataUrl;
    var scriptEl = document.querySelector('script[data-fbp-filter-menu-data-url]');
    if (scriptEl) {
      var attr = scriptEl.getAttribute('data-fbp-filter-menu-data-url');
      if (attr) return attr;
    }
    return resolveAssetUrl('fbp-filter-menu-data.json');
  }

  function parseMultiParam(searchParams, key) {
    return unique(searchParams.getAll(key).map(normalizeText));
  }

  function setDataset(payload) {
    DATA = payload || {};
    INDEX.productTypes = new Map((DATA.productTypes || []).map(function (entry) { return [entry.key, entry]; }));
    INDEX.categories = new Map((DATA.dakiCategories || []).map(function (entry) { return [entry.key, entry]; }));
    INDEX.sortModes = new Map((DATA.sortModes || []).map(function (entry) { return [entry.key, entry]; }));
    INDEX.artists = new Map((DATA.artists || []).map(function (entry) { return [entry.key, entry]; }));
    INDEX.genders = new Map((DATA.genders || []).map(function (entry) { return [entry.key, entry]; }));
  }

  function cloneState(state) {
    return {
      productTypeKey: state.productTypeKey,
      categoryKeys: (state.categoryKeys || []).slice(),
      artistKeys: (state.artistKeys || []).slice(),
      genders: (state.genders || []).slice(),
      sortKey: state.sortKey || DEFAULT_SORT_KEY,
      desktopCollapsed: !!state.desktopCollapsed,
    };
  }

  function productTypeByKey(key) {
    return key ? INDEX.productTypes.get(key) || null : null;
  }

  function categoryByKey(key) {
    return key ? INDEX.categories.get(key) || null : null;
  }

  function sortModeByKey(key) {
    return key ? INDEX.sortModes.get(key) || null : null;
  }

  function artistByKey(key) {
    return key ? INDEX.artists.get(key) || null : null;
  }

  function genderByKey(key) {
    return key ? INDEX.genders.get(key) || null : null;
  }

  function preserveParams(targetUrl, sourceUrl) {
    PRESERVE_PARAM_KEYS.forEach(function (key) {
      targetUrl.searchParams.delete(key);
      sourceUrl.searchParams.getAll(key).forEach(function (value) {
        targetUrl.searchParams.append(key, value);
      });
    });
  }

  function inferProductTypeKey(pathname) {
    var normalized = normalizePath(pathname);
    var byPath = (DATA.productTypes || []).find(function (entry) {
      return normalizePath(entry.path) === normalized;
    });
    if (byPath) return byPath.key;
    if ((DATA.dakiCategories || []).some(function (entry) { return normalizePath(entry.path) === normalized; })) {
      return 'daki';
    }
    if ((DATA.sortModes || []).some(function (entry) { return normalizePath(entry.path) === normalized; })) {
      return 'daki';
    }
    return 'daki';
  }

  function normalizePath(pathname) {
    return String(pathname || '').replace(/\/+$/, '') || '/';
  }

  function isManagedCollectionPath(pathname) {
    var normalized = normalizePath(pathname);
    if (normalized === ALL_PRODUCTS_PATH) return true;
    return (DATA.productTypes || []).some(function (entry) {
      return normalizePath(entry.path) === normalized;
    }) ||
      (DATA.dakiCategories || []).some(function (entry) {
        return normalizePath(entry.path) === normalized;
      }) ||
      (DATA.sortModes || []).some(function (entry) {
        return normalizePath(entry.path) === normalized;
      });
  }

  function shouldUseCollectionRebuild() {
    if (!isCollectionPage() || !DATA) return false;
    var url = new URL(window.location.href);
    return isManagedCollectionPath(url.pathname);
  }

  function inferCategoryKeys(pathname, searchParams, productTypeKey) {
    if (productTypeKey !== 'daki') return ['all-daki'];
    var custom = parseMultiParam(searchParams, 'fbp_cat');
    if (custom.length) return custom;
    var normalized = normalizePath(pathname);
    var byPath = (DATA.dakiCategories || []).find(function (entry) {
      return normalizePath(entry.path) === normalized;
    });
    if (byPath) return [byPath.key];
    return ['all-daki'];
  }

  function inferSortKey(pathname, searchParams) {
    var queryValue = normalizeText(searchParams.get('fbp_sort') || searchParams.get('sort_by') || searchParams.get('sortby'));
    if (queryValue === 'best-selling') {
      return 'best-selling-all-time';
    }
    if (queryValue && SORT_OPTION_LABELS[queryValue]) {
      return queryValue;
    }
    var normalized = normalizePath(pathname);
    var byPath = (DATA.sortModes || []).find(function (entry) {
      return normalizePath(entry.path) === normalized;
    });
    return byPath ? byPath.key : DEFAULT_SORT_KEY;
  }

  function buildInitialState() {
    var url = new URL(window.location.href);
    return normalizeState({
      productTypeKey: inferProductTypeKey(url.pathname),
      categoryKeys: inferCategoryKeys(url.pathname, url.searchParams, inferProductTypeKey(url.pathname)),
      artistKeys: parseMultiParam(url.searchParams, 'fbp_artist').concat(
        parseMultiParam(url.searchParams, 'filter.p.product_type').map(slugify),
      ),
      genders: parseMultiParam(url.searchParams, 'fbp_gender').concat(
        parseMultiParam(url.searchParams, 'filter.p.m.custom.gender'),
      ),
      sortKey: inferSortKey(url.pathname, url.searchParams),
      desktopCollapsed: false,
    });
  }

  function normalizeState(rawState) {
    var next = {
      productTypeKey: rawState.productTypeKey == null ? null : (productTypeByKey(rawState.productTypeKey) ? rawState.productTypeKey : 'daki'),
      categoryKeys: unique(rawState.categoryKeys),
      artistKeys: unique(rawState.artistKeys).filter(function (key) { return !!artistByKey(key); }),
      genders: unique(rawState.genders).filter(function (key) {
        return !!genderByKey(key);
      }),
      sortKey: SORT_OPTION_LABELS[rawState.sortKey] ? rawState.sortKey : DEFAULT_SORT_KEY,
      desktopCollapsed: !!rawState.desktopCollapsed,
    };

    if (next.productTypeKey !== 'daki') {
      next.categoryKeys = [];
      if (next.sortKey === 'best-selling-all-time' || next.sortKey === 'best-selling-30-days') {
        next.sortKey = DEFAULT_SORT_KEY;
      }
      return next;
    }

    next.categoryKeys = next.categoryKeys.filter(function (key) {
      return !!categoryByKey(key);
    });

    if (next.categoryKeys.indexOf('all-daki') >= 0 && next.categoryKeys.length > 1) {
      next.categoryKeys = next.categoryKeys.filter(function (key) { return key !== 'all-daki'; });
    }

    return next;
  }

  function productMatchesSectionlessState(product, baseState, excludedSection) {
    if (!product) return false;

    if (excludedSection !== 'productType' && baseState.productTypeKey) {
      if (product.primaryProductTypeKey !== baseState.productTypeKey) {
        return false;
      }
    }

    if (
      baseState.productTypeKey === 'daki' &&
      excludedSection !== 'categories' &&
      baseState.categoryKeys &&
      baseState.categoryKeys.length &&
      baseState.categoryKeys.indexOf('all-daki') === -1
    ) {
      var hasCategory = baseState.categoryKeys.some(function (key) {
        return (product.speciesKeys || []).indexOf(key) >= 0;
      });
      if (!hasCategory) return false;
    }

    if (excludedSection !== 'artists' && baseState.artistKeys && baseState.artistKeys.length) {
      if (baseState.artistKeys.indexOf(product.artistKey) === -1) {
        return false;
      }
    }

    if (excludedSection !== 'genders' && baseState.genders && baseState.genders.length) {
      var hasGender = (product.genders || []).some(function (value) {
        return baseState.genders.indexOf(value) >= 0;
      });
      if (!hasGender) return false;
    }

    return true;
  }

  function filterProductsForState(state) {
    return (DATA.products || []).filter(function (product) {
      return productMatchesSectionlessState(product, state);
    });
  }

  function productsMatchingStateExcept(state, excludedSection) {
    return (DATA.products || []).filter(function (product) {
      return productMatchesSectionlessState(product, state, excludedSection);
    });
  }

  function countProductsBy(products, keyResolver) {
    var counts = new Map();
    (products || []).forEach(function (product) {
      unique(keyResolver(product) || []).forEach(function (key) {
        if (!key) return;
        counts.set(key, (counts.get(key) || 0) + 1);
      });
    });
    return counts;
  }

  function sortProducts(products, state) {
    var list = (products || []).slice();
    var sortKey = state.sortKey || DEFAULT_SORT_KEY;

    if (sortKey === 'best-selling-all-time' || sortKey === 'best-selling-30-days') {
      var sortConfig = sortModeByKey(sortKey);
      var ranking = new Map((sortConfig && sortConfig.order ? sortConfig.order : []).map(function (handle, index) {
        return [handle, index];
      }));
      list.sort(function (left, right) {
        var leftRank = ranking.has(left.handle) ? ranking.get(left.handle) : Number.MAX_SAFE_INTEGER;
        var rightRank = ranking.has(right.handle) ? ranking.get(right.handle) : Number.MAX_SAFE_INTEGER;
        if (leftRank !== rightRank) return leftRank - rightRank;
        return normalizeText(left.title).localeCompare(normalizeText(right.title));
      });
      return list;
    }

    if (sortKey === 'price-ascending') {
      list.sort(function (left, right) { return Number(left.price.amount) - Number(right.price.amount); });
      return list;
    }

    if (sortKey === 'price-descending') {
      list.sort(function (left, right) { return Number(right.price.amount) - Number(left.price.amount); });
      return list;
    }

    if (sortKey === 'title-ascending') {
      list.sort(function (left, right) { return normalizeText(left.title).localeCompare(normalizeText(right.title)); });
      return list;
    }

    if (sortKey === 'title-descending') {
      list.sort(function (left, right) { return normalizeText(right.title).localeCompare(normalizeText(left.title)); });
      return list;
    }

    if (sortKey === 'created-descending' || sortKey === 'created-ascending') {
      /* Use Shopify product GID as a proxy for creation date (higher ID = newer) */
      function extractId(product) {
        var gid = product.id || '';
        var num = String(gid).replace(/\D/g, '');
        return num ? Number(num) : 0;
      }
      if (sortKey === 'created-descending') {
        list.sort(function (a, b) { return extractId(b) - extractId(a); });
      } else {
        list.sort(function (a, b) { return extractId(a) - extractId(b); });
      }
      return list;
    }

    var productType = productTypeByKey(state.productTypeKey);
    var featuredOrder = new Map((((productType && productType.featuredOrder) || [])).map(function (handle, index) {
      return [handle, index];
    }));

    list.sort(function (left, right) {
      var leftRank = featuredOrder.has(left.handle) ? featuredOrder.get(left.handle) : Number.MAX_SAFE_INTEGER;
      var rightRank = featuredOrder.has(right.handle) ? featuredOrder.get(right.handle) : Number.MAX_SAFE_INTEGER;
      if (leftRank !== rightRank) return leftRank - rightRank;
      return normalizeText(left.title).localeCompare(normalizeText(right.title));
    });

    return list;
  }

  function collectSectionOptions(state) {
    var productTypeMatches = productsMatchingStateExcept(state, 'productType');
    var productTypeCounts = countProductsBy(productTypeMatches, function (product) {
      return [product.primaryProductTypeKey];
    });

    var productTypeOptions = (DATA.productTypes || []).map(function (entry) {
      var count = productTypeCounts.get(entry.key) || 0;
      return {
        key: entry.key,
        label: entry.label,
        count: count,
        active: state.productTypeKey === entry.key,
        disabled: count === 0,
      };
    });

    var categoryOptions = [];
    if (state.productTypeKey === 'daki') {
      var categoryMatches = productsMatchingStateExcept(state, 'categories').filter(function (product) {
        return product.primaryProductTypeKey === 'daki';
      });
      var categoryCounts = countProductsBy(categoryMatches, function (product) {
        return (product.speciesKeys || []).concat('all-daki');
      });

      categoryOptions = (DATA.dakiCategories || []).map(function (entry) {
        var count = categoryCounts.get(entry.key) || 0;
        return {
          key: entry.key,
          label: entry.label,
          count: count,
          active: state.categoryKeys.indexOf(entry.key) >= 0,
          disabled: count === 0 && entry.key !== 'all-daki',
        };
      });
    }

    var artistCounts = countProductsBy(productsMatchingStateExcept(state, 'artists'), function (product) {
      return [product.artistKey];
    });
    var artistOptions = (DATA.artists || [])
      .map(function (entry) {
        var count = artistCounts.get(entry.key) || 0;
        return {
          key: entry.key,
          label: entry.name,
          count: count,
          avatarFilename: entry.avatarFilename,
          placeholder: entry.placeholder,
          active: state.artistKeys.indexOf(entry.key) >= 0,
        };
      })
      .filter(function (entry) { return entry.count > 0 || entry.active; });

    var genderCounts = countProductsBy(productsMatchingStateExcept(state, 'genders'), function (product) {
      return product.genders || [];
    });
    var genderOptions = (DATA.genders || []).map(function (entry) {
      var count = genderCounts.get(entry.key) || 0;
      return {
        key: entry.key,
        label: entry.label,
        count: count,
        active: state.genders.indexOf(entry.key) >= 0,
        disabled: count === 0,
      };
    });

    return {
      productTypeOptions: productTypeOptions,
      categoryOptions: categoryOptions,
      artistOptions: artistOptions,
      genderOptions: genderOptions,
    };
  }

  function buildSelectedChips(state) {
    var chips = [];
    var productType = productTypeByKey(state.productTypeKey);
    if (productType) {
      chips.push({ section: 'productType', key: productType.key, label: 'Product type: ' + productType.label });
    }

    if (state.productTypeKey === 'daki') {
      state.categoryKeys.forEach(function (key) {
        var category = categoryByKey(key);
        if (!category) return;
        chips.push({ section: 'categories', key: key, label: 'Category: ' + category.label });
      });
    }

    state.artistKeys.forEach(function (key) {
      var artist = artistByKey(key);
      if (!artist) return;
      chips.push({ section: 'artists', key: key, label: 'Artist: ' + artist.name });
    });

    state.genders.forEach(function (key) {
      chips.push({ section: 'genders', key: key, label: 'Gender: ' + key });
    });

    return chips;
  }

  function defaultStateForClearAll() {
    return normalizeState({
      productTypeKey: null,
      categoryKeys: [],
      artistKeys: [],
      genders: [],
      sortKey: DEFAULT_SORT_KEY,
      desktopCollapsed: STATE ? STATE.desktopCollapsed : false,
    });
  }

  function buildUrlForState(state) {
    var current = new URL(window.location.href);
    var next = new URL(window.location.href);
    FILTER_DATA_PARAM_KEYS.forEach(function (key) {
      next.searchParams.delete(key);
    });
    next.searchParams.delete('filter.p.product_type');
    next.searchParams.delete('filter.p.m.custom.gender');
    next.searchParams.delete('page');
    next.searchParams.delete('sort_by');
    next.searchParams.delete('sortby');

    var productType = productTypeByKey(state.productTypeKey);
    next.pathname = productType ? normalizePath(productType.path) : ALL_PRODUCTS_PATH;

    if (state.productTypeKey === 'daki') {
      if (state.sortKey === 'best-selling-all-time') {
        var bsAll = sortModeByKey('best-selling-all-time');
        if (bsAll) next.pathname = normalizePath(bsAll.path);
      } else if (state.sortKey === 'best-selling-30-days') {
        var bs30 = sortModeByKey('best-selling-30-days');
        if (bs30) next.pathname = normalizePath(bs30.path);
      } else if (state.categoryKeys.length === 1 && state.categoryKeys[0] !== 'all-daki') {
        var category = categoryByKey(state.categoryKeys[0]);
        if (category) next.pathname = normalizePath(category.path);
      }
    }

    if (state.productTypeKey && state.productTypeKey !== 'daki') {
      next.searchParams.set('fbp_type', state.productTypeKey);
    }

    if (state.productTypeKey === 'daki' && !(state.categoryKeys.length === 1 && state.categoryKeys[0] === 'all-daki')) {
      state.categoryKeys.forEach(function (key) {
        next.searchParams.append('fbp_cat', key);
      });
    }

    state.artistKeys.forEach(function (key) {
      next.searchParams.append('fbp_artist', key);
    });

    state.genders.forEach(function (key) {
      next.searchParams.append('fbp_gender', key);
    });

    if (state.sortKey && state.sortKey !== DEFAULT_SORT_KEY && state.sortKey !== 'best-selling-all-time' && state.sortKey !== 'best-selling-30-days') {
      next.searchParams.set('fbp_sort', state.sortKey);
    }

    preserveParams(next, current);
    return next;
  }

  function pushStateFromCurrent(replace) {
    var next = buildUrlForState(STATE);
    var nextHref = next.toString();
    if (nextHref === window.location.href) return;
    if (replace) {
      history.replaceState({ fbpFilterMenu: true }, '', nextHref);
      return;
    }
    history.pushState({ fbpFilterMenu: true }, '', nextHref);
  }

  function matchesSearch(entry, query) {
    if (!query) return true;
    return normalizeText(entry.label).toLowerCase().indexOf(normalizeText(query).toLowerCase()) >= 0;
  }

  function buildOptionHtml(sectionKey, option) {
    var check = '<span class="fbp-filter-option-check" aria-hidden="true">' + (option.active ? '&#10003;' : '') + '</span>';
    var avatar = '';
    if (sectionKey === 'artists') {
      if (option.avatarFilename) {
        avatar =
          '<img class="fbp-filter-option-avatar" src="' +
          escapeHtml(resolveAssetUrl(option.avatarFilename)) +
          '" alt="" loading="lazy" decoding="async" onerror="this.style.display=\'none\';this.nextElementSibling && (this.nextElementSibling.hidden=false);">' +
          '<span class="fbp-filter-option-avatar-fallback" hidden>' +
          escapeHtml(option.placeholder || option.label.charAt(0).toUpperCase()) +
          '</span>';
      } else {
        avatar =
          '<span class="fbp-filter-option-avatar-fallback">' +
          escapeHtml(option.placeholder || option.label.charAt(0).toUpperCase()) +
          '</span>';
      }
    }

    return [
      '<button type="button" class="fbp-filter-option' +
        (option.active ? ' is-active' : '') +
        (option.disabled ? ' is-disabled' : '') +
        '" data-section="' +
        escapeHtml(sectionKey) +
        '" data-key="' +
        escapeHtml(option.key) +
        '" aria-pressed="' +
        String(!!option.active) +
        '"' +
        (option.disabled ? ' disabled' : '') +
        '>',
      check,
      '<span class="fbp-filter-option-main">',
      avatar,
      '<span class="fbp-filter-option-label">' + escapeHtml(option.label) + '</span>',
      '</span>',
      '<span class="fbp-filter-option-count">(' + escapeHtml(String(option.count)) + ')</span>',
      '</button>',
    ].join('');
  }

  function renderSection(sectionKey, options, searchValue) {
    var section = SECTION_CONFIG[sectionKey] || { title: sectionKey };
    var title = section.title;
    var filtered = (options || []).filter(function (entry) {
      return matchesSearch(entry, searchValue);
    });
    return [
      '<section class="fbp-filter-section" data-section-root="' + escapeHtml(sectionKey) + '">',
      '<div class="fbp-filter-section-head">',
      '<h3 class="fbp-filter-section-title">' + escapeHtml(title) + '</h3>',
      '</div>',
      '<input class="fbp-filter-search" data-search-section="' + escapeHtml(sectionKey) + '" type="search" placeholder="Search ' + escapeHtml(title.toLowerCase()) + '..." value="' + escapeHtml(searchValue || '') + '">',
      '<div class="fbp-filter-options">',
      filtered.length
        ? filtered.map(function (option) { return buildOptionHtml(sectionKey, option); }).join('')
        : '<div class="fbp-filter-no-results">No matches in this section right now.</div>',
      '</div>',
      '</section>',
    ].join('');
  }

  function ensureSidebarMount() {
    var sidebar = document.querySelector('.shop-sidebar-wrap.filter-sidebar');
    if (!sidebar) return null;
    document.body.classList.add(READY_CLASS);
    var root = sidebar.querySelector('.fbp-filter-rebuild-root');
    if (!root) {
      root = document.createElement('div');
      root.className = 'fbp-filter-rebuild-root';
      sidebar.appendChild(root);
    }
    UI.sidebarRoot = root;
    return root;
  }

  function ensureTopBarReferences() {
    UI.topBar = document.querySelector('.shop-top-bar');
    UI.filterButton = UI.topBar ? UI.topBar.querySelector('.filter-button') : null;
    UI.grid = document.querySelector('#product-grid');
    UI.gridWrap = document.querySelector('.shop-product-wrap');
    UI.sortHost = UI.topBar ? UI.topBar.querySelector('.product-short') : null;

    /* If .product-short doesn't exist (setting disabled), create it so sort always works */
    if (UI.topBar && !UI.sortHost) {
      var ps = document.createElement('div');
      ps.className = 'product-short';
      UI.topBar.appendChild(ps);
      UI.sortHost = ps;
    }
  }

  function syncMobileFilterDrawer(forceOpen) {
    var sidebar = document.querySelector('.shop-sidebar-wrap.filter-sidebar');
    if (!sidebar) return;
    var productSidebar = document.querySelector('.pro-grli-wrap.product-sidebar');
    var open = typeof forceOpen === 'boolean' ? forceOpen : document.body.classList.contains(FILTER_OPEN_CLASS);

    if (open && isMobileViewport()) {
      sidebar.style.setProperty('visibility', 'visible', 'important');
      sidebar.style.setProperty('opacity', '1', 'important');
      sidebar.style.setProperty('pointer-events', 'auto', 'important');
      sidebar.style.setProperty('transform', 'translateX(0)', 'important');
      sidebar.style.setProperty('display', 'block', 'important');
      if (productSidebar) {
        productSidebar.style.setProperty('display', 'block', 'important');
      }
      return;
    }

    sidebar.style.removeProperty('display');
    sidebar.style.removeProperty('pointer-events');
    if (isMobileViewport()) {
      sidebar.style.setProperty('visibility', 'hidden', 'important');
      sidebar.style.setProperty('opacity', '0', 'important');
      sidebar.style.setProperty('pointer-events', 'none', 'important');
      sidebar.style.setProperty('transform', 'translateX(-105%)', 'important');
      if (productSidebar) {
        productSidebar.style.removeProperty('display');
      }
      return;
    }

    sidebar.style.removeProperty('visibility');
    sidebar.style.removeProperty('opacity');
    sidebar.style.removeProperty('transform');
    if (productSidebar) {
      productSidebar.style.removeProperty('display');
    }
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function filterScrollContainer() {
    if (isMobileViewport() && document.body.classList.contains(FILTER_OPEN_CLASS)) {
      var sidebar = document.querySelector('.shop-sidebar-wrap.filter-sidebar');
      if (sidebar) return sidebar;
    }
    return document.scrollingElement || document.documentElement || document.body;
  }

  function anchorTopWithinContainer(element, container) {
    if (!element || !container) return null;
    var rect = element.getBoundingClientRect();
    if (
      container === document.body ||
      container === document.documentElement ||
      container === document.scrollingElement
    ) {
      return rect.top;
    }
    return rect.top - container.getBoundingClientRect().top;
  }

  function buildInteractionAnchorDescriptor(source) {
    var node = source && source.nodeType === 1 ? source : null;
    if (node && node.closest) {
      var option = node.closest('.fbp-filter-option');
      if (option) {
        var optionSection = option.getAttribute('data-section');
        return {
          selector: '[data-section-root="' + cssEscape(optionSection) + '"]',
          fallbackSelector: '[data-section-root="' + cssEscape(optionSection) + '"]',
        };
      }

      var search = node.closest('.fbp-filter-search');
      if (search) {
        var searchSection = search.getAttribute('data-search-section');
        return {
          selector: '.fbp-filter-search[data-search-section="' + cssEscape(searchSection) + '"]',
          fallbackSelector: '[data-section-root="' + cssEscape(searchSection) + '"]',
          restoreFocus: true,
          selectionStart: typeof search.selectionStart === 'number' ? search.selectionStart : null,
          selectionEnd: typeof search.selectionEnd === 'number' ? search.selectionEnd : null,
        };
      }

      if (node.closest('.fbp-filter-chip-remove')) {
        return {
          selector: '.fbp-filter-chip-row',
          fallbackSelector: '.fbp-filter-rebuild-root',
        };
      }

      if (node.closest('.fbp-filter-clear-all')) {
        return {
          selector: '.fbp-filter-chip-row',
          fallbackSelector: '.fbp-filter-rebuild-root',
        };
      }
    }

    return {
      selector: '.fbp-filter-rebuild-root',
      fallbackSelector: '.fbp-filter-rebuild-root',
    };
  }

  function captureInteractionAnchor(source) {
    var descriptor = buildInteractionAnchorDescriptor(source);
    if (!descriptor) return null;
    var target =
      document.querySelector(descriptor.selector) ||
      document.querySelector(descriptor.fallbackSelector);
    var container = filterScrollContainer();
    if (!target || !container) return null;
    return {
      selector: descriptor.selector,
      fallbackSelector: descriptor.fallbackSelector,
      restoreFocus: !!descriptor.restoreFocus,
      selectionStart: descriptor.selectionStart,
      selectionEnd: descriptor.selectionEnd,
      containerMode:
        container === document.body ||
        container === document.documentElement ||
        container === document.scrollingElement
          ? 'page'
          : 'sidebar',
      top: anchorTopWithinContainer(target, container),
    };
  }

  function restoreInteractionAnchor(anchor) {
    if (!anchor) return;
    var target =
      document.querySelector(anchor.selector) ||
      document.querySelector(anchor.fallbackSelector);
    if (!target) return;

    var container =
      anchor.containerMode === 'sidebar'
        ? document.querySelector('.shop-sidebar-wrap.filter-sidebar')
        : document.scrollingElement || document.documentElement || document.body;
    if (!container) return;

    var currentTop = anchorTopWithinContainer(target, container);
    if (currentTop == null || anchor.top == null) return;
    var delta = currentTop - anchor.top;
    if (Math.abs(delta) > 1) {
      if (anchor.containerMode === 'sidebar') {
        container.scrollTop += delta;
      } else {
        window.scrollBy(0, delta);
      }
    }

    if (anchor.restoreFocus && typeof target.focus === 'function') {
      target.focus({ preventScroll: true });
      if (
        typeof anchor.selectionStart === 'number' &&
        typeof anchor.selectionEnd === 'number' &&
        typeof target.setSelectionRange === 'function'
      ) {
        var valueLength = String(target.value || '').length;
        target.setSelectionRange(
          Math.min(anchor.selectionStart, valueLength),
          Math.min(anchor.selectionEnd, valueLength),
        );
      }
    }
  }

  function requestInteractionAnchorRestore(anchor) {
    if (!anchor) return;
    requestAnimationFrame(function () {
      restoreInteractionAnchor(anchor);
      setTimeout(function () {
        restoreInteractionAnchor(anchor);
      }, 80);
      setTimeout(function () {
        restoreInteractionAnchor(anchor);
      }, 220);
    });
  }

  function replaceFilterButton() {
    ensureTopBarReferences();
    if (!UI.filterButton) return null;
    if (UI.filterButton.dataset.fbpFilterTriggerRebuilt === '1') return UI.filterButton;
    var clone = UI.filterButton.cloneNode(true);
    clone.dataset.fbpFilterTriggerRebuilt = '1';
    UI.filterButton.parentNode.replaceChild(clone, UI.filterButton);
    UI.filterButton = clone;
    return clone;
  }

  function updateGridColumnMode() {
    if (STATE.desktopCollapsed) {
      document.body.classList.add(FILTER_COLLAPSED_CLASS);
    } else {
      document.body.classList.remove(FILTER_COLLAPSED_CLASS);
    }
  }

  function isDesktopFilterCollapsed() {
    return document.body.classList.contains(FILTER_COLLAPSED_CLASS) || document.body.classList.contains(LEGACY_FILTER_COLLAPSED_CLASS);
  }

  /* ============================================================
   *  Custom sort dropdown — rebuilt from scratch 2026-04-06
   *  Uses a button + body-level panel so it escapes all
   *  ancestor overflow:hidden and z-index stacking issues.
   * ============================================================ */
  var SORT_OPTIONS = [
    { key: 'manual',               label: 'Featured' },
    { key: 'best-selling-all-time', label: 'Best selling all times' },
    { key: 'best-selling-30-days',  label: 'Best selling (30 days)' },
    { key: 'title-ascending',       label: 'Alphabetically, A\u2013Z' },
    { key: 'title-descending',      label: 'Alphabetically, Z\u2013A' },
    { key: 'created-descending',    label: 'Date, new to old' },
    { key: 'created-ascending',     label: 'Date, old to new' },
  ];

  function currentSortLabel() {
    var key = STATE ? STATE.sortKey : DEFAULT_SORT_KEY;
    for (var i = 0; i < SORT_OPTIONS.length; i++) {
      if (SORT_OPTIONS[i].key === key) return SORT_OPTIONS[i].label;
    }
    return 'Featured';
  }

  function ensureSortPanel() {
    var panel = document.getElementById('fbp-sort-panel');
    if (panel) return panel;
    panel = document.createElement('div');
    panel.id = 'fbp-sort-panel';
    panel.className = 'fbp-sort-panel';
    panel.style.display = 'none';
    document.body.appendChild(panel);
    return panel;
  }

  function renderSortPanelItems(panel) {
    var key = STATE ? STATE.sortKey : DEFAULT_SORT_KEY;
    panel.innerHTML = SORT_OPTIONS.map(function (opt) {
      var active = opt.key === key ? ' fbp-sort-option-active' : '';
      return '<button type="button" class="fbp-sort-option' + active + '" data-sort-key="' + escapeHtml(opt.key) + '">' + escapeHtml(opt.label) + '</button>';
    }).join('');
  }

  function positionSortPanel(trigger, panel) {
    var rect = trigger.getBoundingClientRect();
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var scrollX = window.pageXOffset || document.documentElement.scrollLeft;
    panel.style.position = 'absolute';
    panel.style.top = (rect.bottom + scrollY + 4) + 'px';
    /* Align right edge of panel with right edge of trigger */
    var panelWidth = Math.max(rect.width, 260);
    panel.style.width = panelWidth + 'px';
    panel.style.left = (rect.right + scrollX - panelWidth) + 'px';
  }

  var _sortPanelOpen = false;
  function openSortPanel() {
    var trigger = document.querySelector('.fbp-sort-trigger');
    if (!trigger) return;
    var panel = ensureSortPanel();
    renderSortPanelItems(panel);
    positionSortPanel(trigger, panel);
    panel.style.display = 'block';
    _sortPanelOpen = true;
  }
  function closeSortPanel() {
    var panel = document.getElementById('fbp-sort-panel');
    if (panel) panel.style.display = 'none';
    _sortPanelOpen = false;
  }
  function toggleSortPanel() {
    _sortPanelOpen ? closeSortPanel() : openSortPanel();
  }

  function renderSortControl() {
    if (!UI.sortHost) return;
    var shell = UI.sortHost.querySelector('.fbp-sort-shell');
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'fbp-sort-shell';
      UI.sortHost.innerHTML = '';
      UI.sortHost.appendChild(shell);
    }

    shell.innerHTML = [
      '<span class="fbp-sort-label">Sort by:</span>',
      '<button type="button" class="fbp-sort-trigger" aria-haspopup="listbox" aria-label="Sort products">',
        '<span class="fbp-sort-trigger-text">' + escapeHtml(currentSortLabel()) + '</span>',
        '<span class="fbp-sort-trigger-arrow">\u25BE</span>',
      '</button>',
      '<span class="fbp-sort-count"></span>',
    ].join('');

    /* Update trigger text if it already existed */
    var triggerText = shell.querySelector('.fbp-sort-trigger-text');
    if (triggerText) triggerText.textContent = currentSortLabel();
  }

  function sortControlNeedsSanitizing() {
    if (!UI.sortHost) return false;
    /* Custom dropdown: just check if trigger text is out of sync */
    var triggerText = UI.sortHost.querySelector('.fbp-sort-trigger-text');
    if (!triggerText) return true; /* trigger missing — need full render */
    return triggerText.textContent !== currentSortLabel();
  }

  function sanitizeSortControlIfNeeded() {
    if (!UI.sortHost || UI.sortHost.dataset.fbpSortSanitizing === '1') return;
    if (!sortControlNeedsSanitizing()) return;
    UI.sortHost.dataset.fbpSortSanitizing = '1';
    renderSortControl();
    bindSortUi();
    renderResultSummary(filteredAndSortedProducts());
    requestAnimationFrame(function () {
      if (UI.sortHost) {
        UI.sortHost.dataset.fbpSortSanitizing = '0';
      }
    });
  }

  function bindSortSanitizer() {
    if (!UI.sortHost || UI.sortHost.dataset.fbpSortObserverBound === '1') return;
    UI.sortHost.dataset.fbpSortObserverBound = '1';
    var observer = new MutationObserver(function () {
      sanitizeSortControlIfNeeded();
    });
    observer.observe(UI.sortHost, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });
  }

  function updateFilterButtonLabel() {
    if (!UI.filterButton) return;
    var label = UI.filterButton.querySelector('span');
    if (!label) return;
    if (isMobileViewport()) {
      label.textContent = document.body.classList.contains(FILTER_OPEN_CLASS) ? 'Close' : 'Filter';
      UI.filterButton.setAttribute('aria-pressed', document.body.classList.contains(FILTER_OPEN_CLASS) ? 'true' : 'false');
      return;
    }
    label.textContent = isDesktopFilterCollapsed() ? 'Show filter' : 'Hide filter';
    UI.filterButton.setAttribute('aria-pressed', isDesktopFilterCollapsed() ? 'true' : 'false');
  }

  function renderChipRow(chips) {
    return [
      '<div class="fbp-filter-chip-row">',
      chips.map(function (chip) {
        return '<span class="fbp-filter-chip"><strong>' + escapeHtml(chip.label) + '</strong><button type="button" class="fbp-filter-chip-remove" data-chip-section="' + escapeHtml(chip.section) + '" data-chip-key="' + escapeHtml(chip.key) + '" aria-label="Remove ' + escapeHtml(chip.label) + '">&times;</button></span>';
      }).join(''),
      chips.length ? '<button type="button" class="fbp-filter-clear-all">Clear all</button>' : '',
      '</div>',
    ].join('');
  }

  function renderSidebarSections(sections) {
    var blocks = [renderSection('productType', sections.productTypeOptions, SEARCH_STATE.productType)];
    if (STATE.productTypeKey === 'daki') {
      blocks.push(renderSection('categories', sections.categoryOptions, SEARCH_STATE.categories));
    }
    blocks.push(renderSection('artists', sections.artistOptions, SEARCH_STATE.artists));
    blocks.push(renderSection('genders', sections.genderOptions, SEARCH_STATE.genders));
    return blocks.join('');
  }

  function renderSidebar() {
    var root = ensureSidebarMount();
    if (!root) return;

    var sections = collectSectionOptions(STATE);
    var chips = buildSelectedChips(STATE);

    root.innerHTML = [
      '<div class="fbp-filter-rebuild-head">',
      '<h2 class="fbp-filter-rebuild-title">Filter</h2>',
      '<button type="button" class="fbp-filter-rebuild-close" aria-label="Close filters">&times;</button>',
      '</div>',
      renderChipRow(chips),
      renderSidebarSections(sections),
    ].join('');

    var bottomClose = root.parentElement.querySelector('.fbp-filter-bottom-close');
    if (!bottomClose) {
      bottomClose = document.createElement('div');
      bottomClose.className = 'fbp-filter-bottom-close';
      bottomClose.innerHTML = '<button type="button">Close</button>';
      root.parentElement.appendChild(bottomClose);
      bottomClose.querySelector('button').addEventListener('click', function () {
        closeMobileFilter();
      });
    }
  }

  function renderGrid(products) {
    if (!UI.grid) return;
    UI.grid.innerHTML = products.length
      ? products.map(function (product) { return product.cardHtml; }).join('')
      : '<li class="fbp-grid-empty"><strong>No matching products</strong><span>Try removing one or more filters.</span></li>';

    Array.prototype.forEach.call(UI.grid.querySelectorAll(':scope > li'), function (item) {
      if (item.classList.contains('fbp-grid-empty')) return;
      item.classList.remove('grid-1', 'grid-2', 'grid-3', 'grid-4');
      item.classList.add(STATE.desktopCollapsed ? 'grid-4' : 'grid-3');
    });

    window.__fbpCollectionPartialUpdateCount = Number(window.__fbpCollectionPartialUpdateCount || 0) + 1;

    if (UI.gridWrap) {
      UI.gridWrap.classList.remove('grid-1', 'grid-2', 'grid-3', 'grid-4');
      UI.gridWrap.classList.add(STATE.desktopCollapsed ? 'grid-4' : 'grid-3');
    }

    /* Inject gender info into product cards */
    injectGenderLabels(products);
  }

  function injectGenderLabels(products) {
    if (!DATA || !UI.grid) return;
    var productMap = new Map((DATA.products || []).map(function (p) { return [p.handle, p]; }));
    UI.grid.querySelectorAll('[data-fbp-product-handle]').forEach(function (card) {
      var handle = card.getAttribute('data-fbp-product-handle');
      var product = productMap.get(handle);
      if (!product) return;
      /* Skip if already injected */
      if (card.querySelector('.product-gender')) return;
      var genders = product.genders || [];
      if (genders.length === 0) return;
      /* Find anchor: prefer .product-species, fall back to .product-artist, then .product-title */
      var anchor = card.querySelector('.product-species') || card.querySelector('.product-artist') || card.querySelector('.product-title');
      if (!anchor) return;
      var genderHtml = '<p class="product-gender" style="font-size:13px;color:#888;margin:2px 0 4px;text-align:center;">Gender: ';
      genderHtml += genders.map(function (g) {
        return '<a class="fbp-gender-filter-link" href="#" data-fbp-filter-type="gender" data-fbp-filter-value="' + escapeHtml(g) + '" aria-label="Show all ' + escapeHtml(g) + ' products">' + escapeHtml(g) + '</a>';
      }).join(', ');
      genderHtml += '</p>';
      anchor.insertAdjacentHTML('afterend', genderHtml);
    });
  }

  function renderResultSummary(products) {
    var count = UI.sortHost ? UI.sortHost.querySelector('.fbp-sort-count') : null;
    if (count) {
      count.textContent = products.length + ' products';
      return;
    }
    if (!UI.topBar) return;
    var host = UI.topBar.querySelector('.fbp-product-result-copy');
    if (!host) {
      host = document.createElement('div');
      host.className = 'fbp-product-result-copy';
      UI.topBar.appendChild(host);
    }
    host.textContent = products.length + ' products';
  }

  function currentHeadingLabel() {
    if (!STATE.productTypeKey) return 'All Products';
    if (STATE.productTypeKey !== 'daki') {
      var productType = productTypeByKey(STATE.productTypeKey);
      return productType ? productType.label : 'Products';
    }
    if (STATE.categoryKeys.length === 1) {
      var category = categoryByKey(STATE.categoryKeys[0]);
      if (category) return category.label;
    }
    return 'Dakimakura';
  }

  function updateCollectionHeading(products) {
    var title = document.querySelector('.collection-img-wrap .st-title');
    if (!title) return;
    title.textContent = currentHeadingLabel() + ' (' + products.length + ')';
  }

  function filteredAndSortedProducts() {
    return sortProducts(filterProductsForState(STATE), STATE);
  }

  function rerender(skipUrlPush) {
    ensureTopBarReferences();
    renderSidebar();
    renderSortControl();
    bindSortUi();
    updateGridColumnMode();
    updateFilterButtonLabel();
    syncMobileFilterDrawer();
    var products = filteredAndSortedProducts();
    renderGrid(products);
    renderResultSummary(products);
    updateCollectionHeading(products);
    if (!skipUrlPush) {
      pushStateFromCurrent(false);
    }
  }

  function setState(nextState, options) {
    var anchor = options && options.anchor ? captureInteractionAnchor(options.anchor) : null;
    STATE = normalizeState(nextState);
    rerender(!!(options && options.skipUrlPush));
    restoreInteractionAnchor(anchor);
    requestInteractionAnchorRestore(anchor);
  }

  function toggleListValue(values, key) {
    var next = new Set(values || []);
    if (next.has(key)) {
      next.delete(key);
    } else {
      next.add(key);
    }
    return Array.from(next);
  }

  function clearAllFilters(source) {
    setState(defaultStateForClearAll(), { skipUrlPush: false, anchor: source });
  }

  function toggleProductType(key, source) {
    var next = cloneState(STATE);
    next.productTypeKey = STATE.productTypeKey === key ? null : key;
    next.categoryKeys = next.productTypeKey === 'daki' ? ['all-daki'] : [];
    if (!next.productTypeKey) {
      next.sortKey = DEFAULT_SORT_KEY;
    }
    setState(next, { anchor: source });
  }

  function toggleCategory(key, source) {
    var next = cloneState(STATE);
    if (key === 'all-daki') {
      next.categoryKeys =
        next.categoryKeys.length === 1 && next.categoryKeys[0] === 'all-daki'
          ? []
          : ['all-daki'];
      setState(next, { anchor: source });
      return;
    }
    var set = new Set(next.categoryKeys);
    set.delete('all-daki');
    next.categoryKeys = toggleListValue(Array.from(set), key);
    setState(next, { anchor: source });
  }

  function toggleArtist(key, source) {
    var next = cloneState(STATE);
    next.artistKeys = toggleListValue(next.artistKeys, key);
    setState(next, { anchor: source });
  }

  function toggleGender(key, source) {
    var next = cloneState(STATE);
    next.genders = toggleListValue(next.genders, key);
    setState(next, { anchor: source });
  }

  function removeChip(section, key, source) {
    if (section === 'productType') {
      var next = cloneState(STATE);
      next.productTypeKey = null;
      next.categoryKeys = [];
      if (next.sortKey === 'best-selling-all-time' || next.sortKey === 'best-selling-30-days') {
        next.sortKey = DEFAULT_SORT_KEY;
      }
      setState(next, { anchor: source });
      return;
    }
    if (section === 'categories') {
      if (key === 'all-daki') {
        var nextCategoryState = cloneState(STATE);
        nextCategoryState.categoryKeys = [];
        setState(nextCategoryState, { anchor: source });
        return;
      }
      toggleCategory(key, source);
      return;
    }
    if (section === 'artists') {
      toggleArtist(key, source);
      return;
    }
    if (section === 'genders') {
      toggleGender(key, source);
    }
  }

  function openMobileFilter() {
    ensureFilterOverlay();
    document.body.classList.add(FILTER_OPEN_CLASS);
    syncMobileFilterDrawer(true);
    updateFilterButtonLabel();
  }

  function closeMobileFilter() {
    document.body.classList.remove(FILTER_OPEN_CLASS);
    syncMobileFilterDrawer(false);
    updateFilterButtonLabel();
  }

  function toggleFilterSurface() {
    if (isMobileViewport()) {
      if (document.body.classList.contains(FILTER_OPEN_CLASS)) {
        closeMobileFilter();
      } else {
        openMobileFilter();
      }
      return;
    }
    var next = cloneState(STATE);
    next.desktopCollapsed = !next.desktopCollapsed;
    setState(next);
  }

  function handleFilterButtonEvent(event) {
    if (!event) {
      toggleFilterSurface();
      return;
    }
    if (event.__fbpFilterTriggerHandled) return;
    event.__fbpFilterTriggerHandled = true;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    if (event.type && event.type !== 'click') {
      return;
    }
    toggleFilterSurface();
  }

  function bindFilterUi() {
    if (!UI.sidebarRoot) return;

    UI.sidebarRoot.addEventListener('input', function (event) {
      var search = event.target.closest('.fbp-filter-search');
      if (!search) return;
      var section = search.getAttribute('data-search-section');
      if (!section) return;
      var anchor = captureInteractionAnchor(search);
      SEARCH_STATE[section] = search.value || '';
      renderSidebar();
      restoreInteractionAnchor(anchor);
      requestInteractionAnchorRestore(anchor);
    });

    UI.sidebarRoot.addEventListener('click', function (event) {
      var option = event.target.closest('.fbp-filter-option');
      if (option) {
        var section = option.getAttribute('data-section');
        var key = option.getAttribute('data-key');
        if (section === 'productType') toggleProductType(key, option);
        if (section === 'categories') toggleCategory(key, option);
        if (section === 'artists') toggleArtist(key, option);
        if (section === 'genders') toggleGender(key, option);
        return;
      }

      var clearAll = event.target.closest('.fbp-filter-clear-all');
      if (clearAll) {
        clearAllFilters(clearAll);
        return;
      }

      if (event.target.closest('.fbp-filter-rebuild-close')) {
        closeMobileFilter();
        return;
      }

      var chipRemove = event.target.closest('.fbp-filter-chip-remove');
      if (chipRemove) {
        removeChip(
          chipRemove.getAttribute('data-chip-section'),
          chipRemove.getAttribute('data-chip-key'),
          chipRemove,
        );
      }
    });
  }

  function bindGridGenderLinks() {
    if (!UI.grid) return;
    UI.grid.addEventListener('click', function (event) {
      var link = event.target.closest('.fbp-gender-filter-link');
      if (!link) return;
      event.preventDefault();
      var genderValue = link.getAttribute('data-fbp-filter-value');
      if (!genderValue) return;
      var next = cloneState(STATE);
      next.genders = toggleListValue(next.genders, genderValue);
      setState(next, { anchor: link });
    });
  }

  function bindSortUi() {
    if (!UI.sortHost) return;
    /* Trigger button toggles the body-level panel */
    var trigger = UI.sortHost.querySelector('.fbp-sort-trigger');
    if (!trigger || trigger.dataset.fbpSortBound === '1') return;
    trigger.dataset.fbpSortBound = '1';
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleSortPanel();
    });
    /* Global listeners — bind only once */
    if (!window.__fbpSortGlobalBound) {
      window.__fbpSortGlobalBound = true;
      /* Panel option clicks */
      document.addEventListener('click', function (e) {
        var opt = e.target.closest('.fbp-sort-option');
        if (opt && opt.dataset.sortKey) {
          e.preventDefault();
          e.stopPropagation();
          var next = cloneState(STATE);
          next.sortKey = opt.dataset.sortKey || DEFAULT_SORT_KEY;
          closeSortPanel();
          setState(next);
          return;
        }
        /* Close panel on outside click */
        if (_sortPanelOpen) {
          var panel = document.getElementById('fbp-sort-panel');
          var trig = document.querySelector('.fbp-sort-trigger');
          if (panel && !panel.contains(e.target) && trig && !trig.contains(e.target)) {
            closeSortPanel();
          }
        }
      });
      /* Close on Escape */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && _sortPanelOpen) closeSortPanel();
      });
      /* Reposition on scroll/resize */
      function reposition() {
        if (!_sortPanelOpen) return;
        var t = document.querySelector('.fbp-sort-trigger');
        var p = document.getElementById('fbp-sort-panel');
        if (t && p) positionSortPanel(t, p);
      }
      window.addEventListener('scroll', reposition, { passive: true });
      window.addEventListener('resize', reposition, { passive: true });
    }
  }

  function bindTopBarButton() {
    var trigger = replaceFilterButton();
    if (!trigger || trigger.dataset.fbpFilterRebuildBound === '1') return;
    trigger.dataset.fbpFilterRebuildBound = '1';
    trigger.addEventListener('click', function (event) {
      handleFilterButtonEvent(event);
    });
  }

  function ensureFilterOverlay() {
    var overlay = document.getElementById('fbp-filter-mobile-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'fbp-filter-mobile-overlay';
      document.body.appendChild(overlay);
    }
    if (overlay.dataset.fbpFilterOverlayBound !== '1') {
      overlay.dataset.fbpFilterOverlayBound = '1';
      overlay.addEventListener('click', closeMobileFilter);
    }
    UI.mobileOverlay = overlay;
  }

  function collectMenuTree() {
    var root =
      document.querySelector('.header-element.megamenu-content .main-menu.menu-center') ||
      document.querySelector('.main-menu-area .main-menu');
    if (!root) return [];

    function walkList(list) {
      return Array.prototype.map.call(list.children || [], function (item) {
        var primary = item.querySelector(':scope > a.link-title, :scope > a.link-title-lg, :scope > a');
        var submenu = item.querySelector(':scope > ul');
        var text = normalizeText(primary ? primary.textContent : '');
        if (!text) return null;
        return {
          key: slugify(text + '-' + (primary.getAttribute('href') || '')),
          label: text,
          href: primary.getAttribute('href') || '#',
          children: submenu ? walkList(submenu).filter(Boolean) : [],
        };
      }).filter(Boolean);
    }

    return walkList(root);
  }

  function ensureMobileMenuSurface() {
    document.body.classList.add(MENU_READY_CLASS);

    var overlay = document.getElementById('fbp-mobile-menu-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'fbp-mobile-menu-overlay';
      document.body.appendChild(overlay);
    }

    var drawer = document.getElementById('fbp-mobile-menu-drawer');
    if (!drawer) {
      drawer = document.createElement('div');
      drawer.id = 'fbp-mobile-menu-drawer';
      document.body.appendChild(drawer);
    }

    UI.mobileMenuOverlay = overlay;
    UI.mobileMenuDrawer = drawer;
  }

  function replaceMobileMenuTrigger() {
    var trigger = document.querySelector('.navbar-toggle');
    if (!trigger) return null;
    if (trigger.dataset.fbpMenuTriggerRebuilt === '1') return trigger;
    var clone = trigger.cloneNode(true);
    clone.dataset.fbpMenuTriggerRebuilt = '1';
    trigger.parentNode.replaceChild(clone, trigger);
    return clone;
  }

  function renderMobileMenu() {
    ensureMobileMenuSurface();
    var tree = collectMenuTree();
    UI.mobileMenuDrawer.innerHTML = [
      '<div class="fbp-mobile-menu-head"><strong>Menu</strong><button type="button" class="fbp-mobile-menu-close" aria-label="Close menu">&times;</button></div>',
      '<div class="fbp-mobile-menu-scroll">',
      renderMobileMenuList(tree),
      '</div>',
    ].join('');
  }

  function renderMobileMenuList(items) {
    return [
      '<ul>',
      (items || []).map(function (item) {
        return [
          '<li>',
          '<div class="fbp-mobile-menu-row">',
          '<a class="fbp-mobile-menu-link" href="' + escapeHtml(item.href) + '">' + escapeHtml(item.label) + '</a>',
          item.children && item.children.length
            ? '<button type="button" class="fbp-mobile-menu-toggle" data-menu-key="' + escapeHtml(item.key) + '" aria-expanded="false">+</button>'
            : '<span></span>',
          '</div>',
          item.children && item.children.length
            ? '<div class="fbp-mobile-submenu" data-menu-submenu="' + escapeHtml(item.key) + '">' + renderMobileMenuList(item.children) + '</div>'
            : '',
          '</li>',
        ].join('')
      }).join(''),
      '</ul>',
    ].join('');
  }

  function openMobileMenu() {
    document.body.classList.add(MENU_OPEN_CLASS);
    document.body.classList.add(MENU_OPENING_CLASS);
    if (MENU_OPENING_TIMER) {
      window.clearTimeout(MENU_OPENING_TIMER);
    }
    MENU_OPENING_TIMER = window.setTimeout(function () {
      document.body.classList.remove(MENU_OPENING_CLASS);
      MENU_OPENING_TIMER = 0;
    }, MENU_OPENING_GRACE_MS);
  }

  function closeMobileMenu() {
    document.body.classList.remove(MENU_OPEN_CLASS);
    document.body.classList.remove(MENU_OPENING_CLASS);
    if (MENU_OPENING_TIMER) {
      window.clearTimeout(MENU_OPENING_TIMER);
      MENU_OPENING_TIMER = 0;
    }
  }

  function bindMobileMenu() {
    var trigger = replaceMobileMenuTrigger();
    if (trigger && trigger.dataset.fbpMenuRebuildBound !== '1') {
      trigger.dataset.fbpMenuRebuildBound = '1';
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        openMobileMenu();
      }, true);
    }

    if (UI.mobileMenuOverlay && UI.mobileMenuOverlay.dataset.fbpMenuRebuildBound !== '1') {
      UI.mobileMenuOverlay.dataset.fbpMenuRebuildBound = '1';
      UI.mobileMenuOverlay.addEventListener('click', closeMobileMenu);
    }

    if (!UI.mobileMenuDrawer || UI.mobileMenuDrawer.dataset.fbpMenuRebuildBound === '1') return;
    UI.mobileMenuDrawer.dataset.fbpMenuRebuildBound = '1';
    UI.mobileMenuDrawer.addEventListener('click', function (event) {
      if (event.target.closest('.fbp-mobile-menu-close')) {
        closeMobileMenu();
        return;
      }

      var toggle = event.target.closest('.fbp-mobile-menu-toggle');
      if (toggle) {
        var key = toggle.getAttribute('data-menu-key');
        var submenu = UI.mobileMenuDrawer.querySelector('[data-menu-submenu="' + key + '"]');
        if (!submenu) return;
        var open = submenu.classList.toggle('is-open');
        toggle.textContent = open ? '−' : '+';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });
  }

  function bindGlobalCaptureHandlers() {
    if (document.documentElement.dataset.fbpFilterMenuCaptureBound === '1') return;
    document.documentElement.dataset.fbpFilterMenuCaptureBound = '1';

    function intercept(event) {
      var target = event.target;
      if (!(target && target.closest)) return;

      if (isMobileViewport() && target.closest('.navbar-toggle[data-fbp-menu-trigger-rebuilt=\"1\"]')) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        openMobileMenu();
        return;
      }

      /* Sort trigger & panel: intercept to prevent clicks falling through to product cards */
      if (isCollectionPage() && (target.closest('.fbp-sort-trigger') || target.closest('.fbp-sort-panel'))) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        if (target.closest('.fbp-sort-trigger') && event.type === 'click') {
          toggleSortPanel();
        }
        if (target.closest('.fbp-sort-option') && event.type === 'click') {
          var opt = target.closest('.fbp-sort-option');
          var next = cloneState(STATE);
          next.sortKey = opt.dataset.sortKey || DEFAULT_SORT_KEY;
          closeSortPanel();
          setState(next);
        }
        return;
      }

      if (isCollectionPage() && target.closest('.filter-button[data-fbp-filter-trigger-rebuilt="1"]')) {
        handleFilterButtonEvent(event);
        return;
      }

    }

    ['click', 'mousedown', 'pointerdown', 'touchstart', 'change'].forEach(function (eventName) {
      document.addEventListener(eventName, intercept, true);
    });
  }

  function bindBodyStateObserver() {
    if (window.__fbpFilterBodyObserverBound) return;
    window.__fbpFilterBodyObserverBound = true;
    var observer = new MutationObserver(function () {
      updateFilterButtonLabel();
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function loadDataset() {
    if (window.__fbpFilterMenuData && typeof window.__fbpFilterMenuData === 'object') {
      setDataset(window.__fbpFilterMenuData);
      return Promise.resolve(window.__fbpFilterMenuData);
    }
    return fetch(dataUrl(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to load filter data: ' + response.status);
        }
        return response.json();
      })
      .then(function (payload) {
        setDataset(payload);
        return payload;
      });
  }

  function collectionBoot() {
    if (!shouldUseCollectionRebuild()) return;
    ensureTopBarReferences();
    STATE = buildInitialState();
    ensureFilterOverlay();
    ensureSidebarMount();
    renderSidebar();
    renderSortControl();
    updateGridColumnMode();
    updateFilterButtonLabel();
    bindFilterUi();
    bindGridGenderLinks();
    bindSortUi();
    bindSortSanitizer();
    bindTopBarButton();
    bindBodyStateObserver();
    rerender(true);
    sanitizeSortControlIfNeeded();
    setTimeout(sanitizeSortControlIfNeeded, 250);
    setTimeout(sanitizeSortControlIfNeeded, 1200);
  }

  function menuBoot() {
    /* V47 opt-out: header-v2.liquid's inline V47 drawer owns the mobile menu.
       When it sets window.__fbpV47OwnsMobileMenu = true (runs during HTML
       parse, before this DOMContentLoaded boot), skip our legacy mobile-menu
       rebuild so our triggers, drawer, and document-capture intercept don't
       fight V47's open/close. Filter + sort code below is unaffected. */
    if (window.__fbpV47OwnsMobileMenu) {
      /* Still claim the MENU_READY_CLASS so stock main.js's menu handlers
         stand down — V47 relies on the same opt-out. */
      if (document.body) document.body.classList.add(MENU_READY_CLASS);
      return;
    }
    renderMobileMenu();
    bindMobileMenu();
    bindGlobalCaptureHandlers();
  }

  function boot() {
    // Boot the mobile menu immediately so the navbar-toggle tap is owned
    // before the filter dataset fetch resolves. The menu reads its tree from
    // the DOM, not from DATA, so it has no dependency on loadDataset().
    try {
      menuBoot();
    } catch (menuError) {
      if (window.console && typeof window.console.error === 'function') {
        window.console.error('FBP mobile menu rebuild failed to boot', menuError);
      }
    }

    loadDataset()
      .then(function () {
        if (shouldUseCollectionRebuild()) {
          collectionBoot();
        }
      })
      .catch(function (error) {
        window.__fbpFilterMenuRebuildError = String(error && error.message ? error.message : error);
        if (window.console && typeof window.console.error === 'function') {
          window.console.error('FBP filter/menu rebuild failed to boot', error);
        }
      });
  }

  window.addEventListener('popstate', function () {
    if (!DATA) return;
    if (shouldUseCollectionRebuild()) {
      STATE = buildInitialState();
      rerender(true);
    }
  });

  window.addEventListener('resize', function () {
    updateFilterButtonLabel();
    if (!isMobileViewport()) {
      closeMobileFilter();
      closeMobileMenu();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
